<template>
  <div class="login">
    <div class="logos">
      <!-- <img src="../assets/sjfx.png" alt=""> -->
      <img src="../assets/logos.png" alt="" />
    </div>
    <div class="top">
      <img src="../assets/fh.png" />
      <div>登录</div>
    </div>
    <div class="bottom">
      <div class="dl_title">
        <div class="wrap" v-if="loginMode">
          <!-- <div></div> -->
          <p>验证码登录</p>
        </div>
        <div class="wrap2" v-if="!loginMode">
          <!-- <div></div> -->
          <p>密码登录</p>
        </div>
      </div>
      <div class="note" v-if="loginMode">新用户登录后将自动创建账号</div>
      <div class="inp">
        <div v-show="loginMode">
          <div ref="captcha" class="yidunde" v-show="tel.length == 11" name="我是易盾"></div>
        </div>
        <van-field v-model="tel" type="tel" maxlength="11" placeholder="请输入手机号" class="sj" />

        <van-field v-if="loginMode" @input="input" v-model="sms" maxlength="6" center clearable placeholder="请输入验证码"
          type="number">
          <template #button>
            <van-button size="small" type="primary" v-if="loginMode" v-show="codeStatus" @click="getCode"
              style="color: red;">发送验证码</van-button>
            <van-button size="small" type="primary" v-show="!codeStatus">{{ count }}s后重发</van-button>
          </template>
        </van-field>
        <p v-if="loginMode" @click="loginSwitch">密码登录</p>
        <p v-if="!loginMode" @click="loginSwitch">验证码登录</p>
        <van-button type="info" :style="loginStyle" @click="signIn">登录</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  sendcode,
  userlogin,
} from "../api/api.js";
import { mapState } from "vuex";
export default {
  // 13393656462  654321
  data() {
    return {
      info_lists: [],
      sj: "",
      form: "password",
      kj: true,
      validate: "",
      count: "",
      timer: null,
      codeStatus: true,
      tel: "",
      text: "",
      digit: "",
      number: "",
      password: "",
      loginMode: true,
      loginStyle: {
        "background-color": "#f3f3f3 !important", //输入密码后改变样式
      },
      sms: "",
    };
  },
  computed: {
    ...mapState(["guid"]),
    ...mapState(["userInfo"]),
    ...mapState(["configID"]),
    ...mapState(["agentCode"]),
  },
  created() { },
  mounted() {
    this.loginYD();
  },
  methods: {
    //网易易盾
    loginYD() {
      var self = this;
      var options = {
        element: this.$refs.captcha,
        captchaId: "9eb25e37fcd34904914c9986b1b0e265",
        mode: "popup",
        width: "320px",
      };
      var captchaIns;
      var that = this;
      initNECaptcha(
        {
          element: this.$refs.captcha,
          captchaId: "9eb25e37fcd34904914c9986b1b0e265",
          mode: "popup", // 仅智能无感知验证码时，mode 才能设置为 bind
          width: "320px",
          enableClose: true, // 由业务方控制验证码弹框关闭
          // feedbackEnable: false, // 业务方关闭反馈入口
          onVerify: function (err, data) {
            // 用户验证码验证成功后，进行实际的提交行为
            that.validate = data.validate;
            // todo
            if (!err) {
              //验证成功后，调用close方法关闭弹框（enableClose为true时调用）
              captchaIns.close();
            }
          },
        },
        function (instance) {
          // 初始化成功后得到验证实例instance，可以调用实例的方法
          // 禁止在初始化后立即调用instance.verify，详情参见常见问题-前端接入问题
          captchaIns = instance;
        },
        function (err) {
          // 初始化失败后触发该函数，err对象描述当前错误信息
        }
      );
    },
    kjFun() {
      //密码不显示状态
      this.kj = false;
      this.form = "text";
    },
    bkjFun() {
      //密码显示状态
      this.kj = true;
      this.form = "password";
    },
    input() {
      //输入密码后改变样式
      if (this.password != "" || this.sms != "") {
        this.loginStyle = {
          "background-color": "#6a9eea !important",
          color: "#fff",
        };
      } else {
        this.loginStyle = {
          "background-color": "#f3f3f3 !important",
          color: "#c2c2c2",
        };
      }
    },

    getCode() {
      if (this.validate == "") {
        this.$toast("请先完成手机号认证");
        return;
      }
      //获取验证码
      var params = {
        phone: this.tel,
        agentCode: localStorage.getItem("agentCode"),
        op: "regist",
        isRepeat: 0,
        product: "考试宝典",
        captchaId: "9eb25e37fcd34904914c9986b1b0e265",
        validate: this.validate,
      };
      sendcode(params).then((res) => {
        if (res.data.status == 200) {
          this.$toast(res.data.msg);
          //验证码倒计时
          this.codeStatus = false;
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.codeStatus = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.codeStatus = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
    signIn() {
      var that = this;
      if (this.loginMode != true) {
        //账号密码登录
      } else {
        //验证码登录
        if (this.tel != "" && this.sms != "") {
          var params = {
            userName: this.tel,
            verifyCode: this.sms,
            agentCode: this.agentCode,
            clientType: "抽题组卷H5",
            userAgent: localStorage.getItem("borwser"),
          };
          userlogin(params).then((res) => {
            if (res.data.code == 0) {
              localStorage.setItem("guid", res.data.data.guid);
              this.$router.push({
                path: "/home",
                query: {
                  configID: this.configID,
                  agentCode: this.agentCode,
                },
              });
              this.$sensors.registerPage({
                phonenumber: this.tel,
                userId: res.data.data.userID,
                appid: res.data.data.appid,
              });
            } else {
              this.$toast("用户名或验证码错误");
              this.loginYD();
            }
          });
        } else {
          this.$toast("账号或验证码不能为空");
        }
      }
    },
    onClickLeft() {
      Toast("返回");
    },
    loginSwitch() {
      this.$router.push({
        path: "/login",
      });
    },
  },
};
</script>

<style lang="less">
.login {
  .yidun_intellisense--light.yidun_intellisense--success .yidun_classic-tips {
    margin-top: 10px;
  }

  .yidun_intellisense--light.yidun_intellisense--success .yidun_intelli-control {
    border-color: white;
    background-color: white;
  }

  .yidun_intellisense--light .yidun_intelli-tips {
    font-size: 28px;
    color: #6a9eea;
    margin-top: 10px;
  }

  .yidun_intellisense--light .yidun_intelli-control {
    background-color: white;
    border: 0px;
    width: 175px !important;
  }

  .van-field__button {
    // margin-right: -27px;
  }

  .yidun_intellisense--light .yidun_intelli-control {
    width: 200px;
  }

  .yidun_intellisense--light .yidun_intelli-icon {
    display: none;
  }

  .yidunde {
    position: relative;
    top: 63px;
    float: right;
    z-index: 100;
    right: 30px;
  }

  .van-nav-bar {
    // border-bottom:0.1rem solid white ;
    border: 0px solid white;
  }

  .van-nav-bar__title {
    color: white;
    font-size: 34px;
  }

  .van-button--info {
    width: 90%;
    background-color: #f3f3f3 !important;
    color: #c2c2c2;
    border: 0px;
    border-radius: 0.1rem;
    display: flex;
    justify-content: center;
    margin: 1rem auto;
    height: 90px;
  }

  .van-cell::after {
    border: 0px;
  }

  .van-button::before {
    font-size: 0.37rem;
  }

  .van-button--primary {
    background-color: white;
    color: #333333;
    border: 0px;
  }

  .van-cell {
    // background-color: rgba(249, 248, 253, 1);
    // border-radius: 0.5rem;
    height: 0.9rem;
    margin: auto;
    width: 90%;
    margin-bottom: 0.5rem;
    border-bottom: 0.07rem solid #f2f2f2;
    padding-left: 0px;
    font-size: 30px;
  }

  .van-field__label {
    color: #aaaaaa;
  }

  .van-field__control {
    margin-top: -0.1rem;
  }

  // .van-button__text {
  //   color: red !important;
  // }
  .van-button--small {
    padding-right: 0px;
    margin-right: -23px;
    color: #c2c2c2;
    font-size: 28px;
  }

  .sj {
    margin-top: 1rem;
  }

  .van-nav-bar .van-icon {
    color: white;
    font-size: 0.7rem;
  }

  .van-button--normal {
    font-size: 32px;
  }

  .bottom {
    width: 86%;
    margin: auto;
    text-align: center;

    .dl_title {
      .wrap {

        // margin: 0.6rem 0 15px 15px ;
        p {
          position: relative;
          margin-top: 0px;
          font-size: 45px;
          margin: 0px;
          margin-bottom: 0.3rem;
          font-weight: 700;
          color: #6a9de9;
          letter-spacing: 2px;
        }

        div {
          background-color: rgba(248, 171, 129, 1);
          height: 0.2rem;
          width: 3rem;
          position: absolute;
          top: 2.21rem;
          border-radius: 1rem;
        }
      }

      .wrap2 {

        // margin: 0.6rem 0 15px 15px ;
        p {
          position: relative;
          margin-top: 0px;
          font-size: 45px;
          margin: 0px;
          margin-bottom: 0.3rem;
          font-weight: 700;
          color: #6a9de9;
          letter-spacing: 2px;
        }

        div {
          background-color: rgba(248, 171, 129, 1);
          height: 0.2rem;
          width: 2.4rem;
          position: absolute;
          top: 2.21rem;
          border-radius: 1rem;
        }
      }
    }

    .note {
      margin-left: 15px;
      font-size: 27px;
      color: #c1c1c1;
      margin-bottom: 30px;
      letter-spacing: 2px;
    }

    .inp {
      p {
        text-align: center;
        color: #6a9eea;
        font-size: 28px;
        float: right;
        margin: 0rem 0.46rem 0.5rem 0;
      }
    }
  }

  .top {
    background-image: url(../assets/Path78.png);
    width: 100%;
    height: 347px;
    background-size: 100% 100%;
    display: flex;

    img {
      width: 22px;
      height: 43px;
      margin: 32px 0 0 25px;
    }

    div {
      font-size: 34px;
      font-family: Source Han Sans CN Regular,
        Source Han Sans CN Regular-Regular;
      font-weight: 400;
      color: #fefefe;
      margin-top: 27px;
      margin-left: 292px;
    }
  }
}

.logos {
  position: absolute;
  top: 80px;
  left: 80px;
}

.logos img {
  width: 220px;
  height: 80px;
}
</style>
